import React from "react";
import { SectionTitle } from "./SectionTitle";
import { NewsletterCheckbox } from "./NewsletterCheckbox";
import {ControlledTextField} from "../forms/ControlledTextField";
import {OrderPersonalInformationFields} from "../../types/purchaseOrder/Order";
import { CheckoutFormTypeFields, useCheckoutForm } from "./hooks/useCheckoutForm";
import { CHECKOUT_MAXLEN } from "../../utils/checkoutFieldMaxLengths";

export const ContactSection: React.FC = () => {
  const { methods } = useCheckoutForm();
  const watchSubscribe = methods.watch(CheckoutFormTypeFields.Subscribe);

  const setSubscribe = (value: boolean) =>
    methods.setValue(CheckoutFormTypeFields.Subscribe, value);
  
  return (
    <>
      <SectionTitle>Datos de contacto</SectionTitle>

      <ControlledTextField control={methods.control}
                           label={"E-mail"}
                           name={`${CheckoutFormTypeFields.PersonalInformation}.${OrderPersonalInformationFields.Email}`}
                           inputProps={{ maxLength: CHECKOUT_MAXLEN.vchMail }}
      />

      <NewsletterCheckbox checked={watchSubscribe} onChange={setSubscribe} />
    </>
  )
};














